import { money, marketplace } from '@sellpy/commons'
import { captureException } from '@sentry/react'
import { TOAST_TYPE } from '../uiComponents/notifications/toastState'

/**
 * @description  Returns a zero money object, currency defaults to envionment currency
 * @param {string} currency
 * @returns {{amount: 0, currency: string}}
 */
export const zeroMoney = (currency = marketplace.CURRENCY[process.env.REGION]) => ({
  amount: 0,
  currency
})

export const sumTransactions = (transactions) => {
  const deltas = transactions.map((transaction) => transaction.delta).map(money.toBaseUnit)
  return money.add(...deltas)
}

export const formatOutputValue = (object, creditMultiplier) =>
  money.currencyJSRoundForCreditConversion(
    money.baseUnitToCurrencyJS(money.multiply(creditMultiplier)(object))
  )

export const formatInputValue = (object, creditMultiplier) =>
  money.currencyJSRoundForCreditConversion(
    money.baseUnitToCurrencyJS(money.multiply(1 / creditMultiplier)(object))
  )

export const commonPayoutErrors = (error, t) => {
  const errorType =
    error?.message?.details?._error || error.graphQLErrors?.[0]?.extensions?.details?._error
  const isErrorHandled = [
    'zeroPayableAmount',
    'invalidAmounts',
    'invalidAmount',
    'accountOutsideOfEuOrEes',
    'rejectedAccount',
    'invoiceUser',
    'missingAddress'
  ].includes(errorType)

  const body = isErrorHandled
    ? t(`balance:errorToast.body.${errorType}`)
    : t('common:errorToast.body')

  if (!isErrorHandled) captureException(error)

  return {
    header: t('common:errorToast.header'),
    body,
    type: TOAST_TYPE.ERROR
  }
}

export const normalizeAmount = ({ amount }) => amount && amount.replaceAll(',', '.')

export const normalizeBankAccount = (value) => value && value.replaceAll(/[ -]/g, '')
